import {CommonModule} from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {TuiDataList} from '@taiga-ui/core';
import {MenuItem} from '../gatewee-navigation.component';

const tuiDataList = [...TuiDataList] as const;

/**
 * Renders the Taiga UI data-list content for a single collapsed-rail flyout.
 *
 * Lives in its own file so the navigation component template stays small.
 * ViewEncapsulation.None is required because Taiga UI portals the dropdown
 * content into a CDK overlay outside the component host — attribute-scoped
 * styles would never reach it. The `.gatewee-nav-flyout` class on the root
 * element provides the scoping boundary so rules don't leak elsewhere.
 */
@Component({
  selector: 'gatewee-nav-flyout',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, RouterLink, TranslateModule, ...tuiDataList],
  templateUrl: './gatewee-nav-flyout.component.html',
  styleUrls: ['./gatewee-nav-flyout.component.css'],
})
export class GateweeNavFlyoutComponent {
  @Input({required: true}) item!: MenuItem;

  /** Emitted after any navigable option is clicked so the parent can close the dropdown. */
  @Output() optionSelected = new EventEmitter<void>();

  externalHref(route: string): string {
    return new URL(route, window.location.origin).href;
  }
}
